import * as types from './constants';

// Get Batch Message Templates
export const getBatchMessageTemplatesRequest = data => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATES_REQUEST, payload: data }
);

export const getBatchMessageTemplatesDone = data => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATES_DONE, payload: data }
);

export const getBatchMessageTemplatesFailed = errors => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATES_FAILED, payload: errors }
);

export const getBatchMessageTemplatesReset = () => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATES_RESET }
);

// Operations
export const batchMessageTemplatesSetPage = data => (
  { type: types.BATCH_MESSAGE_TEMPLATES_SET_PAGE, payload: data }
);